var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('statics-count',{attrs:{"sourceType":_vm.sourceType}}),_c('statics-scale',{attrs:{"sourceType":_vm.sourceType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }